// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__16EoM","ranges":"BmiRanges_ranges__1YHAd"};